'use client';
import * as styles from './styles.css';
export { styles as listStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useEffect, useState } from 'react';
import { cx, highlightMatch, KeyboardCode, uniqueId, devWarning } from '@paypalcorp/pp-react-utils';
import { BodyText, CaptionText } from '@paypalcorp/pp-react-text';
import { CheckmarkIcon } from '@paypalcorp/pp-react-icons';

var gutterStyles = ['regular', 'none'];
var verticalSpaces = ['regular', 'condensed'];

var _excluded$1 = ["label", "labelLineClamp", "status", "labelContext", "labelDescription", "labelDescriptionLineClamp", "alert", "action", "value", "decoration", "trailingContent", "navigationOptions", "className", "focusActive", "isFocused", "isHighlighted", "isSelected", "highlightText", "isTextHighlighted", "as", "isItemFocusable", "isItemNavigational", "ariaDescribedby", "role", "gutterStyle", "verticalSpace", "unselectable"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable complexity */
var ListItem = function (_ref) {
  var label = _ref.label,
    labelLineClamp = _ref.labelLineClamp,
    status = _ref.status,
    labelContext = _ref.labelContext,
    labelDescription = _ref.labelDescription,
    labelDescriptionLineClamp = _ref.labelDescriptionLineClamp,
    alert = _ref.alert,
    action = _ref.action;
    _ref.value;
    var decoration = _ref.decoration,
    trailingContent = _ref.trailingContent,
    navigationOptions = _ref.navigationOptions;
    _ref.className;
    _ref.focusActive;
    var isFocused = _ref.isFocused,
    isHighlighted = _ref.isHighlighted,
    isSelected = _ref.isSelected,
    highlightText = _ref.highlightText,
    isTextHighlighted = _ref.isTextHighlighted,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    isItemFocusable = _ref.isItemFocusable,
    isItemNavigational = _ref.isItemNavigational,
    ariaDescribedby = _ref.ariaDescribedby,
    role = _ref.role,
    _ref$gutterStyle = _ref.gutterStyle,
    gutterStyle = _ref$gutterStyle === void 0 ? 'regular' : _ref$gutterStyle,
    _ref$verticalSpace = _ref.verticalSpace,
    verticalSpace = _ref$verticalSpace === void 0 ? 'regular' : _ref$verticalSpace,
    _ref$unselectable = _ref.unselectable,
    unselectable = _ref$unselectable === void 0 ? false : _ref$unselectable,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var listRef = useRef();
  useEffect(function () {
    if (isFocused) {
      listRef.current.focus();
    }
  }, [isFocused]);
  var listItemWrapperClasses = cx(styles.listItemWrapper, styles.verticalSpaces[verticalSpace], isItemNavigational && styles.hoverAndActiveStyles, isHighlighted && styles.highlight, isItemFocusable && styles.focusActive, styles.gutterStyles[gutterStyle], unselectable && styles.unselectable);
  var alignStyleMap = {
    top: styles.alignTop,
    center: styles.alignCenter,
    bottom: styles.alignBottom
  };
  var decorationClasses = cx(styles.decoration, decoration && alignStyleMap[decoration.align]);
  var trailingContentClasses = cx(styles.trailingContent, trailingContent && alignStyleMap[trailingContent.align], styles.checkmarkIcon);
  var navigationProps = navigationOptions && _objectSpread$1({}, navigationOptions);
  var labelProps = {
    as: 'p',
    type: isSelected ? 'strong' : 'regular',
    className: styles.text,
    clampAtLine: labelLineClamp
  };
  var labelDescriptionContent = function (description) {
    var allowLineClamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return description && /*#__PURE__*/React.createElement(CaptionText, _extends({
      as: "p",
      className: styles.labelDescription
    }, allowLineClamp ? {
      clampAtLine: labelDescriptionLineClamp
    } : {}, {
      "data-ppui": "true"
    }), description);
  };
  var actionContent = function (actions) {
    return actions && /*#__PURE__*/React.createElement("div", {
      className: styles.action,
      "data-ppui": "true"
    }, actions);
  };
  return /*#__PURE__*/React.createElement(as, _extends({
    className: listItemWrapperClasses,
    role: role
  }, !unselectable ? {
    tabIndex: -1
  } : null, {
    ref: listRef,
    "aria-describedby": ariaDescribedby
  }, !navigationOptions ? {
    'aria-selected': isSelected !== undefined && isSelected
  } : null, navigationProps, rest, {
    "data-ppui": "true"
  }), (decoration === null || decoration === void 0 ? void 0 : decoration.thumbnail) && /*#__PURE__*/React.createElement("div", {
    className: decorationClasses,
    "data-ppui": "true"
  }, decoration.thumbnail), (!!label || !!alert || !!action || !!status || !!labelContext || !!labelDescription) && /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    "data-ppui": "true"
  }, status && /*#__PURE__*/React.createElement("div", {
    "data-ppui": "true"
  }, status), labelDescriptionContent(labelContext, false), label && function labelHtml() {
    if (isTextHighlighted && typeof label === 'string') {
      var tempLabel = highlightMatch(label, highlightText);
      return /*#__PURE__*/React.createElement(BodyText, _extends({}, labelProps, {
        dangerouslySetInnerHTML: {
          __html: tempLabel
        },
        "data-ppui": "true"
      }));
    }
    return /*#__PURE__*/React.createElement(BodyText, _extends({}, labelProps, {
      "data-ppui": "true"
    }), label);
  }(), labelDescriptionContent(labelDescription, true), alert, actionContent(action)), /*#__PURE__*/React.createElement("div", {
    className: trailingContentClasses,
    "data-ppui": "true"
  }, (trailingContent || isSelected) && /*#__PURE__*/React.createElement(React.Fragment, null, isSelected ? /*#__PURE__*/React.createElement(CheckmarkIcon, {
    "aria-label": "Selected",
    size: "sm",
    color: "SelectedMain",
    "data-ppui": "true"
  }) : null, (trailingContent === null || trailingContent === void 0 ? void 0 : trailingContent.status) && /*#__PURE__*/React.createElement("div", {
    "data-ppui": "true"
  }, trailingContent.status), labelDescriptionContent(trailingContent === null || trailingContent === void 0 ? void 0 : trailingContent.labelContext, false), (trailingContent === null || trailingContent === void 0 ? void 0 : trailingContent.label) && /*#__PURE__*/React.createElement(BodyText, {
    as: "p",
    className: styles.text,
    "data-ppui": "true"
  }, trailingContent.label), labelDescriptionContent(trailingContent === null || trailingContent === void 0 ? void 0 : trailingContent.labelDescription, false), actionContent(trailingContent === null || trailingContent === void 0 ? void 0 : trailingContent.action), actionContent(trailingContent === null || trailingContent === void 0 ? void 0 : trailingContent.icon))));
};

/**
 * Get the selectable index from an array of `ListItem`.
 * @param ListItemProps[] items.
 * @param number current focused index.
 * @param string {'next' | 'previous'} determines in which direction to find the selectable index.
 * @returns `number` index of the selectable item.
 */
var getSelectableIndex = function (items, currentIndex, step) {
  var selectableItemIndexes = [];
  var stepNumber = step === 'previous' ? -1 : 1;
  for (var index = 0; index < items.length; index++) {
    var _items$index;
    if (!((_items$index = items[index]) === null || _items$index === void 0 ? void 0 : _items$index.unselectable)) {
      selectableItemIndexes.push(index);
    }
  }
  if (currentIndex === selectableItemIndexes[0] && step === 'previous') {
    return selectableItemIndexes[selectableItemIndexes.length - 1];
  } else if (currentIndex === selectableItemIndexes[selectableItemIndexes.length - 1] && step === 'next') {
    return selectableItemIndexes[0];
  } else {
    return selectableItemIndexes[selectableItemIndexes.indexOf(currentIndex) + stepNumber];
  }
};

var _excluded = ["options", "focusActive", "activeIndex", "focusedIndex", "className", "onKeyDown", "onClick", "onFocus", "onBlur", "hasSections", "highlightText", "isTextHighlighted", "itemAs", "gutterStyle", "verticalSpace"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var List = React.forwardRef(function (_ref, ref) {
  var options = _ref.options,
    focusActive = _ref.focusActive,
    _ref$activeIndex = _ref.activeIndex,
    activeIndex = _ref$activeIndex === void 0 ? -1 : _ref$activeIndex,
    _ref$focusedIndex = _ref.focusedIndex,
    focusedIndex = _ref$focusedIndex === void 0 ? -1 : _ref$focusedIndex,
    className = _ref.className,
    onKeyDown = _ref.onKeyDown,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    hasSections = _ref.hasSections,
    highlightText = _ref.highlightText,
    isTextHighlighted = _ref.isTextHighlighted,
    _ref$itemAs = _ref.itemAs,
    itemAs = _ref$itemAs === void 0 ? ListItem : _ref$itemAs,
    _ref$gutterStyle = _ref.gutterStyle,
    gutterStyle = _ref$gutterStyle === void 0 ? 'regular' : _ref$gutterStyle,
    _ref$verticalSpace = _ref.verticalSpace,
    verticalSpace = _ref$verticalSpace === void 0 ? 'regular' : _ref$verticalSpace,
    rest = _objectWithoutProperties(_ref, _excluded);
  var listRef = useRef();
  var computedRef = ref || listRef;
  var _useState = useState(focusedIndex),
    _useState2 = _slicedToArray(_useState, 2),
    focusedIndexRef = _useState2[0],
    setFocusedIndex = _useState2[1];
  useEffect(function () {
    setFocusedIndex(focusedIndex);
  }, [focusedIndex]);
  var handleClick = function (evt, index, option) {
    if (option === null || option === void 0 ? void 0 : option.unselectable) {
      return;
    }
    setFocusedIndex(index);
    /* istanbul ignore next */
    if (onClick) {
      onClick(evt, index);
    }
  };

  /**
   * Create a flat list of sectionItems for highlight and selection by index
   * @param items
   * @returns items
   */
  var normalizeSectionItem = function (items) {
    return items.reduce(function (acc, item) {
      /* istanbul ignore next */
      if (item === null || item === void 0 ? void 0 : item.sectionItems) {
        acc.push.apply(acc, _toConsumableArray(item.sectionItems));
      }
      return acc;
    }, []);
  };

  /* istanbul ignore next */

  /* istanbul ignore next */

  /**
   * Render List Items as per configuration.
   * @param optList
   * @param ItemAs
   * @param sectionId
   * @param normalizedIndex
   * @returns JSX.ELEMENT[]
   */
  var listItems = function (optList, ItemAs, sectionId) {
    var normalizedIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return optList.map(function (option, index) {
      var _option$value;
      if (typeof option.label !== 'string' && !option.value) {
        devWarning('When label is a React Element, `value` property is necessary in option');
      }
      var hasOnClick = onClick || option.onClick;
      var isItemNavigational = !!hasOnClick || !!option.navigationOptions;
      var idx = hasSections ? index + normalizedIndex : index;
      var otherProps = {
        value: (_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : option.label,
        role: hasOnClick ? 'option' : null,
        focusActive: focusActive,
        highlightText: highlightText,
        isTextHighlighted: isTextHighlighted,
        isFocused: focusActive && focusedIndexRef === idx,
        isHighlighted: activeIndex === idx,
        isItemNavigational: isItemNavigational,
        isItemFocusable: focusActive !== null && focusActive !== void 0 ? focusActive : isItemNavigational,
        as: option.navigationOptions ? 'a' : 'div',
        ariaDescribedby: hasSections ? sectionId : null,
        gutterStyle: gutterStyles.includes(gutterStyle) ? gutterStyle : 'regular',
        disabled: option.unselectable,
        verticalSpace: verticalSpaces.includes(verticalSpace) ? verticalSpace : 'regular'
      };
      var wrapperProps = _objectSpread({}, option.wrapperProps);
      delete option.wrapperProps; // removing wrapperProps to avoid it from getting passed to children
      return /*#__PURE__*/React.createElement("li", _extends({
        className: option.className,
        role: "menuitem",
        "aria-selected": option.isSelected !== undefined && option.isSelected
        //@ts-ignore
        ,
        onClick: function (evt) {
          return handleClick(evt, idx, option);
        },
        key: idx,
        "data-value": option.value
      }, wrapperProps, {
        "data-ppui": "true"
      }), /*#__PURE__*/React.createElement(ItemAs, _extends({}, otherProps, option, {
        "data-ppui": "true"
      })));
    });
  };
  return /*#__PURE__*/React.createElement("menu", _extends({
    className: cx(styles.base, className),
    ref: computedRef,
    tabIndex: focusActive && focusedIndexRef === -1 ? 0 : -1
  }, rest, {
    onFocus: function handleListFocus(evt) {
      var isFocusedCurrent = focusActive && evt.target === computedRef.current && evt.currentTarget === computedRef.current;
      if (!onKeyDown && isFocusedCurrent) {
        setFocusedIndex(0);
      }
      if (onFocus) {
        onFocus(evt);
      }
    },
    onBlur: function handleListBlur(evt) {
      var isTargetContained = !computedRef.current.contains(evt.target) || !evt.relatedTarget;
      if (!onKeyDown && focusActive && isTargetContained) {
        setFocusedIndex(-1);
      }
      if (onBlur) {
        onBlur(evt);
      }
    },
    onKeyDown: function handleKey(evt) {
      if (onKeyDown) {
        onKeyDown(evt);
        return;
      }
      var listOptions = hasSections ? normalizeSectionItem(options) : options;

      /* istanbul ignore next */
      var KeyCode = new KeyboardCode(evt.key);
      if (KeyCode.IS_ARROW_UP && focusedIndexRef > 0) {
        evt.preventDefault();
        setFocusedIndex(getSelectableIndex(listOptions, focusedIndexRef, 'previous'));
      } else if (KeyCode.IS_ARROW_DOWN && focusedIndexRef < listOptions.length - 1) {
        evt.preventDefault();
        setFocusedIndex(getSelectableIndex(listOptions, focusedIndexRef, 'next'));
      } else if ((KeyCode.IS_ENTER || KeyCode.IS_SPACEBAR) && onClick) {
        evt.preventDefault();
        handleClick(evt, focusedIndexRef);
      }
    },
    "data-ppui": "true"
  }), hasSections ? function listSectionItems(optList, ItemAs) {
    var currentNormalizedIndex = 0;
    return optList.reduce(function (acc, option) {
      var _option$sectionItems;
      if (option === null || option === void 0 ? void 0 : (_option$sectionItems = option.sectionItems) === null || _option$sectionItems === void 0 ? void 0 : _option$sectionItems.length) {
        /* istanbul ignore next */
        var uniqueKey = option.id ? option.id : uniqueId('list_section_id');
        acc.push( /*#__PURE__*/React.createElement("li", {
          role: "presentation",
          key: uniqueKey,
          "data-ppui": "true"
        }, option.title && /*#__PURE__*/React.createElement("div", {
          className: cx(styles.title, styles.verticalSpaces[verticalSpace]),
          id: option.id,
          "aria-hidden": "true",
          "data-ppui": "true"
        }, /*#__PURE__*/React.createElement(CaptionText, {
          "data-ppui": "true"
        }, option.title)), /*#__PURE__*/React.createElement("menu", _extends({
          "aria-labelledby": option.id,
          className: styles.sectionList
        }, rest, {
          "data-ppui": "true"
        }), listItems(option.sectionItems, ItemAs, option.id, currentNormalizedIndex))));
        currentNormalizedIndex += option.sectionItems.length;
      }
      return acc;
    }, []);
  }(options, itemAs) : listItems(options, itemAs));
});

export { List, ListItem, getSelectableIndex, gutterStyles, verticalSpaces };
